import { useTypedSelector } from "@/hooks";
import { useEmailPdfInstallQuery, useFetchEmailPreviewQuery } from "@/services";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
function convertToObject(str) {
  try {
    // Parse the JSON string into a JavaScript object
    const obj = JSON.parse(str);
    return obj;
  } catch (error) {
    console.error("Invalid JSON string:", error);
    return null;
  }
}

// Example usage

const EmailPreview = ({ offerId, companyId, refreshTrigger, handleSubmit, activeKey }) => {
  const { search } = useLocation()
  const isRevised = search === "?mode=revise"
  const { offer_annual } = useTypedSelector(state => state?.offers)
  const typeKey = offer_annual ? "annual" : "monthly";

  const {
    data: htmlContent,
    error,
    isLoading,
    refetch,
  } = useFetchEmailPreviewQuery(
    { company_id: companyId, id: offerId, type: typeKey },
    {
      skip: !offerId || !companyId,
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(async () => {
    if (activeKey == '7') {

      await handleSubmit()
      refetch()
    }

  }, [activeKey])

  useEffect(() => {
    // Trigger a manual refetch when refreshTrigger changes
    if (offerId && companyId) {
      refetch();
    }
  }, [refreshTrigger, offerId, companyId, refetch]);
  const handleDownload = async () => {

    const token = localStorage.getItem("tokens");
    const jsonObject = convertToObject(token);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/company/${companyId}/offer/${offerId}/email-page/pdf/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/pdf",
            "Authorization": `Bearer ${jsonObject.access}`,
          },
        }
      );

      if (!response.ok) throw new Error("Network response was not ok");

      // Convert response to blob
      const blob = await response.blob();

      // Create a temporary link element
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Offer_${offerId}.pdf`; // filename
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };
  return (
    <div className="p-4 h-80 overflow-auto border-b">
      {isLoading && !htmlContent?.data?.body ? (
        <p className="text-center text-gray-500">Loading...</p>
      ) : (
        <div dangerouslySetInnerHTML={{ __html: htmlContent && htmlContent?.data?.body }} />
      )}
    </div>
  );
};

export default EmailPreview;
